/**
 * @desc addToDetail
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TransportToDetailDao, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/addTransportDetail`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
